'use client';

import type { ComponentPropsWithoutRef, Ref } from 'react';

import classnames from 'classnames';

import type { BaseComponentProps } from '../../base-component.types';

import styles from './ImageView.module.scss';

type ContainerProps = ComponentPropsWithoutRef<'div'> &
  BaseComponentProps & {
    heading?: string;
    title: string;
    src: string;
    alt?: string;
  };

export function ImageView({
  style,
  className,
  heading,
  title,
  src,
  alt,
  ref,
  ...rest
}: ContainerProps & { ref?: Ref<HTMLDivElement> }) {
  return (
    <div
      ref={ref}
      style={style}
      className={classnames(styles['main'], className)}
      {...rest}
    >
      <div className={styles['head']}>
        {heading && <span className={styles['heading']}>{heading}</span>}
        <span className={styles['title']}>{title}</span>
      </div>
      <img className={styles['image']} src={src} alt={alt} />
    </div>
  );
}
